/* eslint-disable react-hooks/exhaustive-deps */
import {
  Box,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { useDebounce } from "use-debounce";

import { FadeLoader } from "react-spinners";
import moment from "moment";
import "moment/locale/id";

moment.locale("id");

const KategoriCustomTable = ({
  isLoading,
  headerData,
  Data,
  isAction,
  onSearchData,
  onClickShow,
  onEditData,
  onDeleteData,
  page,
  rowsPerPage,
  TablePagination,
}) => {
  const location = useLocation();
  const path = location.pathname;
  const [search, setSearch] = useState("");
  const [debouncedSearch] = useDebounce(search, 1000);

  useEffect(() => {
    onSearchData(debouncedSearch);
  }, [debouncedSearch]);

  return (
    <TableContainer
      className="rounded-2xl bg-white overflow-x-auto"
      style={{
        boxShadow: "0px 0px 10px rgba(0,0,0,0.1)",
        border: "0.5px solid #fafafa",
        borderRadius: "10px",
        maxHeight: 600, // <-- batasi tinggi agar scroll muncul
        overflowY: "auto", // <-- agar header sticky bisa aktif
      }}
      component={Paper}
    >
      <div className="overflow-x-auto">
        <Box sx={{ height: 500, overflowY: "auto", paddingBottom: 9 }}>
          <Table sx={{ minWidth: 650 }} aria-label="simple table">
            <TableHead
              className="sticky top-0 z-10"
              sx={{
                backgroundColor: "#F5F5F7",
                "& th": {
                  backgroundColor: "#F5F5F7", // wajib untuk sticky
                },
              }}
            >
              <TableRow>
                <TableCell
                  align="center"
                  width="5%"
                  sx={{ fontWeight: "bold" }}
                >
                  No
                </TableCell>
                {headerData.map((header, index) => (
                  <TableCell
                    key={header.key || index}
                    align={header.align}
                    style={{ width: header.width }}
                    className={
                      header.hideOnMobile ? "hidden md:table-cell" : ""
                    }
                    sx={{ fontWeight: "bold" }}
                  >
                    {header.label}
                  </TableCell>
                ))}
                {isAction &&
                (isAction.isShow || isAction.isEdit || isAction.isDelete) ? (
                  <TableCell align="center" sx={{ fontWeight: "bold" }}>
                    Aksi
                  </TableCell>
                ) : null}
              </TableRow>
            </TableHead>

            <TableBody>
              {isLoading ? (
                <TableRow>
                  <TableCell
                    colSpan={headerData.length + 2}
                    align="left"
                    style={{ height: 100 }}
                  >
                    <div className="flex items-center justify-center py-6 gap-3">
                      <div className="scale-57">
                        <FadeLoader height={10} width={5} color="#26a0fc" />
                      </div>
                      <div
                        className="text-sm"
                        style={{ fontFamily: "Poppins" }}
                      >
                        Sedang memuat. . .
                      </div>
                    </div>
                  </TableCell>
                </TableRow>
              ) : Data?.length > 0 ? (
                Data.map((row, index) => (
                  <TableRow key={row.id || index}>
                    <TableCell align="center">
                      {page * rowsPerPage + index + 1}
                    </TableCell>

                    {headerData.map((data, i) => {
                      const rawValue = row[data.key];
                      let displayValue = data.render
                        ? data.render(rawValue)
                        : rawValue;

                      if (
                        rawValue &&
                        (data.key?.toLowerCase().includes("date") ||
                          moment(rawValue, moment.ISO_8601, true).isValid())
                      ) {
                        displayValue = moment(rawValue).format(
                          "DD MMMM YYYY, HH:mm"
                        );
                      }
                      return (
                        <TableCell
                          align={data.align}
                          key={data.key || i}
                          className={
                            data.hideOnMobile ? "hidden md:table-cell" : ""
                          }
                        >
                          {data.key === "is_bwc" ? (
                            row?.is_bwc ? (
                              "Playback"
                            ) : (
                              "Realtime"
                            )
                          ) : typeof rawValue === "boolean" ? (
                            <span
                              className={`inline-flex items-center gap-2 px-4 py-1.5 text-sm rounded-2xl font-medium transition-all duration-300 ${
                                rawValue
                                  ? "bg-green-50 text-green-700"
                                  : "bg-red-50 text-red-700"
                              }`}
                            >
                              <span
                                className={`w-2.5 h-2.5 rounded-full ${
                                  rawValue ? "bg-green-500" : "bg-red-500"
                                } shadow-sm`}
                              ></span>
                              {data.label === "Daftar Pencarian Orang"
                                ? rawValue
                                  ? "Ya"
                                  : "Tidak"
                                : rawValue
                                  ? "Aktif"
                                  : "Tidak Aktif"}
                            </span>
                          ) : (
                            displayValue
                          )}

                          {/* <Tooltip title={row[data.key] || "-"}>
                          <span className=" block max-w-[150px]">
                            {row[data.key] ?? "-"}
                          </span>
                        </Tooltip> */}
                        </TableCell>
                      );
                    })}

                    {isAction &&
                    (isAction.isShow ||
                      isAction.isEdit ||
                      isAction.isDelete) ? (
                      <TableCell align="center">
                        <div className="flex justify-center gap-2">
                          {isAction.isShow && (
                            <button
                              className="h-10 flex w-auto justify-center items-center rounded-xl bg-btn-login hover:bg-opacity-50 px-3 py-1.5 text-sm font-semibold text-white shadow-sm"
                              onClick={() => onClickShow(row)}
                            >
                              <i className="ri-eye-line"></i>
                            </button>
                          )}
                          {isAction.isEdit && (
                            <button
                              className="h-10 flex w-auto justify-center items-center rounded-xl bg-amber-500 hover:bg-opacity-50 px-3 py-1.5 text-sm font-semibold text-white shadow-sm"
                              onClick={() => onEditData(row)}
                            >
                              <i className="ri-pencil-line"></i>
                            </button>
                          )}
                          {isAction.isDelete && (
                            <button
                              className="bg-rose-900 h-10 flex w-auto justify-center items-center rounded-xl hover:bg-opacity-50 px-3 py-1.5 text-sm font-semibold text-white shadow-sm"
                              onClick={() => onDeleteData(row)}
                            >
                              <i className="ri-delete-bin-6-line"></i>
                            </button>
                          )}
                        </div>
                      </TableCell>
                    ) : null}
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell
                    colSpan={headerData.length + 2}
                    align="center"
                    style={{ height: 100 }}
                  >
                    <p className="text-sm" style={{ fontFamily: "Poppins" }}>
                      Tidak Ada Data
                    </p>
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </Box>
      </div>

      {TablePagination}
    </TableContainer>
  );
};

export default KategoriCustomTable;
